var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionForm.jinja"] = require( "submissions/components/SubmissionForm/SubmissionForm.jinja" );
dependencies["submissions/components/SubmissionFormCancel/SubmissionFormCancel.jinja"] = require( "submissions/components/SubmissionFormCancel/SubmissionFormCancel.jinja" );
dependencies["submissions/components/SubmissionFormSaveDraft/SubmissionFormSaveDraft.jinja"] = require( "submissions/components/SubmissionFormSaveDraft/SubmissionFormSaveDraft.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionForm.jinja", false, "assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "SubmissionForm")) {
var t_10 = t_7.SubmissionForm;
} else {
cb(new Error("cannot import 'SubmissionForm'")); return;
}
context.setVariable("SubmissionForm", t_10);
output += "\n";
env.getTemplate("submissions/components/SubmissionFormCancel/SubmissionFormCancel.jinja", false, "assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "SubmissionFormCancel")) {
var t_14 = t_11.SubmissionFormCancel;
} else {
cb(new Error("cannot import 'SubmissionFormCancel'")); return;
}
context.setVariable("SubmissionFormCancel", t_14);
output += "\n";
env.getTemplate("submissions/components/SubmissionFormSaveDraft/SubmissionFormSaveDraft.jinja", false, "assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja", false, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
t_15.getExported(function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
if(Object.prototype.hasOwnProperty.call(t_15, "SubmissionFormSaveDraft")) {
var t_18 = t_15.SubmissionFormSaveDraft;
} else {
cb(new Error("cannot import 'SubmissionFormSaveDraft'")); return;
}
context.setVariable("SubmissionFormSaveDraft", t_18);
output += "\n\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
output += t_19;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"SubmissionPopup\">\n\n        <div class=\"SubmissionPopup-header\">\n            <div class=\"SubmissionPopup-header-title\"><a href=\"";
output += runtime.suppressValue((lineno = 12, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:submissions"])), env.opts.autoescape);
output += "\">Submissions</a></div>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"id")) {
output += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title")) {
output += "\n                    <div class=\"SubmissionPopup-header-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title"), env.opts.autoescape);
output += "</div>\n                ";
;
}
else {
output += "\n                    <div class=\"SubmissionPopup-header-caption\">Untitled Submission</div>\n                ";
;
}
output += "\n            ";
;
}
else {
output += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"typ") == "film") {
output += "\n                    <div class=\"SubmissionPopup-header-caption\">Feature Film</div>\n                ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"typ") == "tv") {
output += "\n                    <div class=\"SubmissionPopup-header-caption\">Television Program, <br>Music Video & Commercial</div>\n                ";
;
}
;
}
output += "\n            ";
;
}
output += "\n\n\n            <div class=\"SubmissionPopup-header-footer\">\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"mode") == "c") {
output += "\n                    <div class=\"SubmissionPopup-header-closed\"><span>THE PERIOD FOR SUBMISSIONS AND ASSETS IS CLOSED</div>\n                ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"mode") == "a") {
output += "\n                    <div class=\"SubmissionPopup-header-closed\"><span>THE PERIOD FOR SUBMISSIONS IS CLOSED,</span> BUT YOU CAN STILL ADD ASSETS TO YOUR SUBMISSION</div>\n                ";
;
}
else {
output += "\n                    <div class=\"SubmissionPopup-header-deadline\"><span>DEADLINE:</span> ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"deadline") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"deadline")),"date")) {
output += runtime.suppressValue(env.getFilter("datetimeNoZeroPadding").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"deadline")),"date"),"%A, %B %d, %Y - %I%p PST"), env.opts.autoescape);
;
}
else {
output += "TBD";
;
}
output += "</div>\n                    <div class=\"SubmissionPopup-header-note\">* PLEASE ENTER ALL THE REQUIRED FIELDS AND MAKE SURE YOU SUBMIT ONE FORM PER PROJECT</div>\n                ";
;
}
;
}
output += "\n            </div>\n        </div>\n\n        <div class=\"SubmissionPopup-content\">\n            <div class=\"SubmissionPopup-application\">\n                ";
output += runtime.suppressValue((lineno = 43, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionForm"), "SubmissionForm", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "popup")})])), env.opts.autoescape);
output += "\n            </div>\n        </div>\n\n        <div class=\"SubmissionPopup-buttons\">\n            <div class=\"SubmissionPopup-buttonsWrapper\">\n                <div class=\"SubmissionPopup-buttonsCancel\">Cancel</div>\n                ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"id") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"state") == 0 && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"state") == 0 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"onlyUploads"))) {
output += "\n                    <div class=\"SubmissionPopup-buttonsSaveDraft\">Save as Draft</div>\n                ";
;
}
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"state") != 0) {
output += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"onlyUploads")) {
output += "\n                        <div class=\"SubmissionPopup-buttonsSubmit\">Add Assets & Submit</div>\n                    ";
;
}
else {
output += "\n                        <div class=\"SubmissionPopup-buttonsSubmit\">Resubmit</div>\n                    ";
;
}
output += "\n                ";
;
}
else {
output += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"onlyUploads")) {
output += "\n                        <div class=\"SubmissionPopup-buttonsSaveDraftUploads\">Add Assets & Save</div>\n                    ";
;
}
else {
output += "\n                    <div class=\"SubmissionPopup-buttonsSubmit\">Submit</div>\n                    ";
;
}
output += "\n                ";
;
}
output += "\n\n\n            </div>\n        </div>\n\n        ";
output += runtime.suppressValue((lineno = 72, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormCancel"), "SubmissionFormCancel", context, [])), env.opts.autoescape);
output += "\n\n        ";
output += runtime.suppressValue((lineno = 74, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormSaveDraft"), "SubmissionFormSaveDraft", context, [])), env.opts.autoescape);
output += "\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/SubmissionPopup/SubmissionPopup.jinja
// module id = 223
// module chunks = 0